import { Content, asText, isFilled } from '@prismicio/client';

import { RichText } from '@preventx/prismic-services';
import { Box, Flex, Heading, LinkAs } from '@preventx/oxygen';

// Services
import { retrieveIcon } from '@/services/utils/icons';
import { applicationEnv } from '@/services/env/shared';

// Components
import { Link } from '@/components/Actions/Link';

type WithSimpleContactDetailsProps = {
  sliceId: string;
  slice: Content.RegionSliceWithSimpleContactDetails;
};

export const WithSimpleContactDetails = ({
  slice,
  sliceId,
}: WithSimpleContactDetailsProps) => {
  const { primary } = slice;
  const { title, content, contact_details } = primary;

  const { WebsiteUrl } = applicationEnv();

  return (
    <Box component="div" className="align-center">
      <Box component="div" addFlow>
        <Heading component="h2" addHeadlineTitle>
          {asText(title)}
        </Heading>

        {isFilled.richText(content) && (
          <Box component="div" className="align-center">
            <RichText
              content={content}
              variant="default"
              websiteUrl={WebsiteUrl}
            />
          </Box>
        )}

        <Flex className="justify-center">
          <Box component="div" addCluster={contact_details.length > 1}>
            {contact_details.map(({ label, contact_value, type }, index) => {
              if (!isFilled.keyText(contact_value)) {
                return null;
              }

              const icon = type !== 'Default' ? retrieveIcon(type) : undefined;

              const as = {
                Email: 'mailto' satisfies LinkAs,
                Default: 'default' satisfies LinkAs,
                Phone: 'telephone' satisfies LinkAs,
              }[type] as LinkAs;

              return (
                <Link
                  as={as}
                  type="button"
                  colour="primary"
                  retainSearchParams
                  href={contact_value}
                  key={`contact-details-region-${sliceId}-${index + 1}`}
                  icon={
                    icon ? { definition: icon, position: 'left' } : undefined
                  }
                >
                  {asText(label)}
                </Link>
              );
            })}
          </Box>
        </Flex>
      </Box>
    </Box>
  );
};
